<template>
  <div class="checkbox">
    <label :for="`checkbox${index}`" class="checkbox_label">
      <a
        :href="builtQueryString"
        :title="tag.tagAllSlug"
        class="active"
      >
        <span>{{ tag.tagName }}</span>
        <i class="lni lni-close"></i>
      </a>
    </label>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TagListingFiltersModel from './tag/filters/Models/TagListingFiltersModel'

export default {
  name: 'AdvListingUsedTag',
  props: {
    group: {
      tagDisplayType: '',
      tagGroupId: '',
      tagGroupName: null,
      tagGroupStep: 0,
      tagGroupDisplayPosition: 0,
      tags: []
    },
    tag: {
      tagDisplayValue: '',
      tagId: '',
      tagName: ''
    },
    index: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapGetters([
      'getActiveTagFilters',
      'getTagRecordsUsed',
      'getFilterQueryStringVar',
      'getUriWithoutOffset',
      'getIsTopLevelCategory',
      'getCurrentPageNumber',
      'getActiveVariationFiltersString',
      'getActiveAttributeFiltersString',
      'config'
    ]),
    builtQueryString () {
      return this.filteringManage(this.group, this.tag)
    },
    activeFiltersString () {
      const variationFiltersString = this.getActiveVariationFiltersString
      const attributeFiltersString = this.getActiveAttributeFiltersString
      if (variationFiltersString !== '' && attributeFiltersString !== '') {
        return variationFiltersString + '&' + attributeFiltersString
      }
      if (variationFiltersString !== '') {
        return variationFiltersString
      }
      if (attributeFiltersString !== '') {
        return attributeFiltersString
      }
      return ''
    }
  },
  methods: {
    filteringManage (group, entry) {
      const isFilterUsed = true
      const duplicateAttributeGroupNamesPerGroup = {}
      return new TagListingFiltersModel(
        this.getUriWithoutOffset,
        this.getFilterQueryStringVar,
        this.getActiveTagFilters,
        this.getIsTopLevelCategory,
        this.getCurrentPageNumber,
        this.config.url.lang,
        this.activeFiltersString,
        duplicateAttributeGroupNamesPerGroup
      ).createLinkQueryStringFinal(group, entry, isFilterUsed)
    }
  }
}
</script>

<style lang="scss" scoped>
.prod_list_header_filters {
  display: grid;
  grid-template-columns: auto auto auto;
  align-items: center;
  margin-bottom: 45px;
}
.checkbox {
  position: relative;
  width: 100%;
  display: grid;
  margin: 0;
  font-size: 14px;
  padding: 0 10px;
  line-height: 1.2;
  font-weight: 500;
  height: 40px;
  border-radius: 21px;
  border:1px solid #F36314;
  .checkbox_label {
    display: flex;
    padding: 0;
    cursor: pointer;
    color: #040403;
    font-size: 12px;
    font-weight: 500;
    line-height: 1.3;
    height: 100%;
    align-items: center;
    align-content: center;
    margin: 0;
    &:before{
      display: none
    }
    a {
      display: grid;
      gap: 5px;
      grid-template-columns: 1fr auto;
      align-items: center;
      i {
        color: #F36314;
        font-size: 13px;
      }
    }
  }
  .checkbox_input:checked+.checkbox_label::before {
    display: none
  }
}
.native_slider-lg {
  border-right: 1px solid #707070;
}
</style>
